import api from './api';

export interface Attachment {
  id: number;
  entity_type: 'case' | 'task' | 'hearing' | 'other';
  entity_id: number;
  filename: string;
  original_filename: string;
  file_path: string;
  file_size: number;
  mime_type?: string;
  document_type?: string;
  description?: string;
  uploaded_at: string;
  uploaded_by: number;
  uploaded_by_name?: string;
}

const attachmentsService = {

  async list(entityType: string, entityId: number): Promise<Attachment[]> {
    const res = await api.get(`/attachments/${entityType}/${entityId}`);
    return res.data.data || [];
  },

  async upload(
    entityType: string,
    entityId: number,
    file: File,
    opts: { description?: string; document_type?: string } = {}
  ): Promise<Attachment> {
    const form = new FormData();
    form.append('file', file);
    if (opts.description)    form.append('description', opts.description);
    if (opts.document_type)  form.append('document_type', opts.document_type);

    const res = await api.post(`/attachments/${entityType}/${entityId}`, form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data.data;
  },

  async download(id: number, filename: string): Promise<void> {
    const res = await api.get(`/attachments/download/${id}`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/attachments/${id}`);
  },

  formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
  },

  getIcon(mimeType?: string, filename?: string): string {
    const ext = (filename || '').split('.').pop()?.toLowerCase() || '';
    if (mimeType?.includes('pdf') || ext === 'pdf') return '📄';
    if (mimeType?.includes('image') || ['jpg','jpeg','png','gif','webp'].includes(ext)) return '🖼️';
    if (['doc','docx'].includes(ext)) return '📝';
    if (['xls','xlsx'].includes(ext)) return '📊';
    if (['zip','rar'].includes(ext)) return '🗜️';
    if (['mp4','mp3'].includes(ext)) return '🎬';
    return '📎';
  }
};

export default attachmentsService;
